import { createFileRoute } from "@tanstack/react-router";
import SelfBodyFrameCosmetics from "@/features/assessments/pages/self-body-frame-cosmetics/SelfBodyFrameCosmetics";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-body-frame-cosmetics")({
	component: SelfBodyFrameCosmetics,
});
